import { cn as e } from "../../shared/utils.js";
import { Popover as t } from "../../popover/primitive/index.js";
import { forwardRef as n } from "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/tooltip/primitive/index.tsx
var i = 300, a = t.Root, o = n(({ className: n, delay: i = 300, openOnHover: a = !0, ...o }, s) => /* @__PURE__ */ r(t.Trigger, {
	ref: s,
	className: e("outline-none", n),
	"data-slot": "tooltip-trigger",
	openOnHover: a,
	delay: i,
	...o
})), s = t.Portal, c = n(({ className: n, sideOffset: i = 6, ...a }, o) => /* @__PURE__ */ r(t.Positioner, {
	ref: o,
	className: e("z-50 outline-none", n),
	sideOffset: i,
	...a
})), l = n(({ className: n, initialFocus: i = !1, ...a }, o) => /* @__PURE__ */ r(t.Popup, {
	ref: o,
	className: e("text-text-secondary max-w-xs min-w-0 px-3 py-2 text-base font-normal wrap-break-word", "origin-(--transform-origin)", "transition-base transition-[opacity,transform]", "data-starting-style:opacity-0", "data-ending-style:opacity-0 data-ending-style:duration-100 data-ending-style:ease-in", "data-[side=top]:data-ending-style:translate-y-[-0.5px] data-[side=top]:data-starting-style:translate-y-[-0.5px]", "data-[side=bottom]:data-ending-style:translate-y-[0.5px] data-[side=bottom]:data-starting-style:translate-y-[0.5px]", "data-[side=left]:data-ending-style:translate-x-[-0.5px] data-[side=left]:data-starting-style:translate-x-[-0.5px]", "data-[side=right]:data-ending-style:translate-x-[0.5px] data-[side=right]:data-starting-style:translate-x-[0.5px]", n),
	...a,
	"data-slot": "tooltip-popup",
	initialFocus: i
})), u = n(({ className: n, ...i }, a) => /* @__PURE__ */ r(t.Arrow, {
	ref: a,
	className: e("bg-bg-primary border-border-100 size-2 rotate-45 border", "data-[side=top]:-bottom-1 data-[side=top]:border-t-0 data-[side=top]:border-l-0", "data-[side=bottom]:-top-1 data-[side=bottom]:border-r-0 data-[side=bottom]:border-b-0", "data-[side=left]:-right-1 data-[side=left]:border-b-0 data-[side=left]:border-l-0", "data-[side=right]:-left-1 data-[side=right]:border-t-0 data-[side=right]:border-r-0", n),
	...i
}));
o.displayName = "Tooltip.Trigger", c.displayName = "Tooltip.Positioner", l.displayName = "Tooltip.Popup", u.displayName = "Tooltip.Arrow";
var d = {
	Root: a,
	Trigger: o,
	Portal: s,
	Positioner: c,
	Popup: l,
	Arrow: u
};
//#endregion
export { i as TOOLTIP_HOVER_DELAY_MS, d as Tooltip, u as TooltipArrow, l as TooltipPopup, s as TooltipPortal, c as TooltipPositioner, a as TooltipRoot, o as TooltipTrigger };
